import { useContext } from 'react';

import { BreadcrumbStateContext } from './BreadcrumbProvider';
import type { Breadcrumb } from './Breadcrumb.types';

export function useBreadcrumbs(): Breadcrumb[] {
  return useContext(BreadcrumbStateContext).crumbTrail;
}
